"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _globals = require("@insided/shared/utils/globals");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var COMMUNITY_VISIBILITY_PUBLIC_STATE = 'public';
var COMMUNITY_VISIBILITY_PRIVATE_STATE = 'private';
var COMMUNITY_VISIBILITY_OFFLINE_STATE = 'offline';
var cssAnchorName = 'powered-by-insided';
exports.cssAnchorName = cssAnchorName;

var PoweredByInsided = function PoweredByInsided(props) {
  return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
    var isCookieBannerEnabled = modules.includes('cookiebar') && !props.cookieConfig.use_external_modal;
    var poweredByDescription = 'Powered by Gainsight';
    var externalLink = 'https://www.gainsight.com/customer-communities/';
    var icon = 'logo-gainsight';
    var title = 'Visit Gainsight.com';
    var showTermsAndConditionsLink = props.communityVisibility === COMMUNITY_VISIBILITY_PUBLIC_STATE || !props.isGuestUser;
    return (0, _preact.h)("div", {
      className: "Template-footer"
    }, (0, _preact.h)("div", {
      className: (0, _classnames.default)('sitewidth', 'box', 'box--blend'),
      "data-component": "scrollTopStickyButton"
    }, (0, _preact.h)("div", {
      className: "templatefoot"
    }, (0, _preact.h)(_phrase.default, {
      p: "accessibility_label.powered_by_gainsight",
      renderAsText: true
    }, function (accessibilityLabel) {
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(externalLink),
        className: icon,
        title: title,
        target: "_blank",
        rel: "noreferrer",
        "aria-label": accessibilityLabel
      }, (0, _preact.h)("span", {
        className: "is-hidden"
      }, poweredByDescription));
    })), (0, _preact.h)("div", {
      className: "templatefoot-privacy-links"
    }, showTermsAndConditionsLink && (0, _preact.h)(_phrase.default, {
      p: "Terms & Conditions",
      renderAsText: true
    }, function (termsAndConditionsPhrase) {
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(props.termsConditions),
        "aria-label": termsAndConditionsPhrase
      }, termsAndConditionsPhrase);
    }), isCookieBannerEnabled && (0, _preact.h)(_phrase.default, {
      p: "cookiepolicy.link",
      renderAsText: true
    }, function (ariaLabel) {
      return (0, _preact.h)("a", {
        href: "#",
        onClick: function onClick() {
          return (0, _globals.publish)('edit_cookie_settings', null);
        },
        "aria-label": ariaLabel
      }, ariaLabel);
    }), (0, _preact.h)("a", {
      href: "https://www.gainsight.com/policy/accessibility-cc/",
      target: "_blank",
      rel: "noreferrer"
    }, "Accessibility statement")), (0, _preact.h)(_phrase.default, {
      p: "branded.back_to_top",
      renderAsText: true
    }, function (phrase) {
      return (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('scroll-to-top-sticky-button', 'js-scrollto', 'widget--base-shadow', 'is-hidden-S', 'custom-scroll-to-top'),
        "aria-label": phrase
      });
    })));
  });
};

var _default = PoweredByInsided;
exports.default = _default;